/**
 * Selector for the default minimum hwe kernel.
 */

import { generateGeneralSelector } from "./utils";

const defaultMinHweKernel = generateGeneralSelector<"defaultMinHweKernel">(
  "defaultMinHweKernel"
);

export default defaultMinHweKernel;
